import { Skeleton } from './skeleton';

export function SkeletonStatTile({ testid = 'skeleton-stat-tile' }) {
  return (
    <div data-testid={testid} className="bg-[var(--bg-L1)] border border-[var(--border-default)] rounded-2xl p-4">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <Skeleton className="h-3 w-16 rounded" />
          <Skeleton className="h-7 w-12 rounded" />
        </div>
        <Skeleton className="h-8 w-8 rounded-full flex-shrink-0" />
      </div>
    </div>
  );
}
